import { SchedulingPage } from "@/features/scheduling/scheduling-page";

export function SchedulingScreen() {
  return <SchedulingPage />;
}
